import React from 'react';

import StatusBadge from '../../../modules/status-badge/status-badge';
import { OrderRealizationsAdjustedItemProps } from '../types';

import './order-realizations-adjusted-item.scss';

interface OrderRealizationsAdjustedItemMergedProps
  extends OrderRealizationsAdjustedItemProps {}

const OrderRealizationsAdjustedItem: React.FC<OrderRealizationsAdjustedItemMergedProps> = ({
  title,
  oldCount,
  count,
  oldSum,
  sum,
}) => {
  const getItemStatusData = () => {
    if (sum === null && count === null) {
      return <StatusBadge title="Исполненое" color="gray" />;
    }
    return <StatusBadge title="Корректировка" color="orange" />;
  };

  return (
    <div className="realization-adjust-item">
      <div className="realization-adjust-item__title">{title}</div>
      <div className="realization-adjust-item__count-old">{oldCount}</div>
      <div className="realization-adjust-item__count">{count ?? '--'}</div>
      <div className="realization-adjust-item__price-old">{oldSum}</div>
      <div className="realization-adjust-item__price">{sum ?? '--'}</div>
      <div className="realization-adjust-item__action">
        {getItemStatusData()}
      </div>
    </div>
  );
};

export default OrderRealizationsAdjustedItem;
